import { getApiUrl } from './api';
import { apiFetch } from './apiFetch';

const API_URL = getApiUrl();

const readJson = async (response, fallbackMessage) => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.error || data.message || fallbackMessage);
    error.status = response.status;
    error.code = data.code;
    throw error;
  }
  return data;
};

const publicFetch = (path, options = {}) => fetch(`${API_URL}${path}`, {
  ...options,
  headers: {
    Accept: 'application/json',
    ...(options.headers || {}),
  },
});

export const tableQrManagerApi = {
  async get(tableId) {
    const response = await apiFetch(`${API_URL}/api/salon/tables/${tableId}/qr`, {
      headers: { Accept: 'application/json' },
    });
    return readJson(response, 'Falha ao carregar o QR Code da mesa.');
  },

  async create(tableId) {
    const response = await apiFetch(`${API_URL}/api/salon/tables/${tableId}/qr`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
    });
    return readJson(response, 'Falha ao gerar o QR Code da mesa.');
  },

  async setEnabled(tableId, enabled) {
    const response = await apiFetch(`${API_URL}/api/salon/tables/${tableId}/qr`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ enabled }),
    });
    return readJson(response, 'Falha ao alterar o QR Code da mesa.');
  },

  async rotate(tableId) {
    const response = await apiFetch(`${API_URL}/api/salon/tables/${tableId}/qr/rotate`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
    });
    return readJson(response, 'Falha ao gerar um novo QR Code para a mesa.');
  },

  async download(tableId) {
    const response = await apiFetch(`${API_URL}/api/salon/tables/${tableId}/qr/image`, {
      headers: { Accept: 'image/png' },
    });
    if (!response.ok) {
      const data = await response.clone().json().catch(() => ({}));
      throw new Error(data.error || 'Falha ao baixar o QR Code da mesa.');
    }
    return response.blob();
  },
};

export const publicTableMenuApi = {
  async context(qrToken) {
    const response = await publicFetch('/api/public/salon/context', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: qrToken }),
    });
    return readJson(response, 'Não foi possível identificar esta mesa.');
  },

  async join(qrToken, customerName) {
    const response = await publicFetch('/api/public/salon/join', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: qrToken, customerName }),
    });
    return readJson(response, 'Não foi possível iniciar o atendimento desta mesa.');
  },

  async catalog(guestToken) {
    const response = await publicFetch('/api/public/salon/catalog', {
      headers: guestToken ? { Authorization: `Bearer ${guestToken}` } : {},
    });
    return readJson(response, 'Não foi possível carregar o cardápio.');
  },

  async createOrder(guestToken, payload) {
    const response = await publicFetch('/api/public/salon/orders', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${guestToken}` },
      body: JSON.stringify(payload),
    });
    return readJson(response, 'Não foi possível enviar o pedido.');
  },
};
